import { useEffect, useRef } from 'react';

// Zwraca sekundowy timestamp
export function getTimestamp() {
  return Math.floor(new Date().getTime() / 1000);
}

// Zwraca timestamp dla początku bieżącego dnia
export function getDailyTimestamp() {
  return Math.floor(new Date().setHours(0,0,0,0) / 1000);
}

// Zamienia sekundy na string w formacie H:mm
export function secsToStr (sec, format) {
  const date = new Date(null);
  date.setSeconds(sec);
  switch (format.toLowerCase()) {
    case 'h:mm':
      return dateToHMM(date);
    case 'h:mm:ss':
      return dateToHMMSS(date);
    case 'h?:mm:ss':
      return dateToHqMMSS(date);
    default:
      return dateToHMMSS(date);
  }
}

// Zamienia datę na string w formacie H:mm:ss
function dateToHMMSS (date) {
  let result = date.toISOString().substr(11, 8);
  return result[0] !== '0' ? result : result.substr(1);
}

// Zamienia datę na string w formacie H?:mm:ss
function dateToHqMMSS (date) {
  let result = dateToHMMSS(date)
  if (result[0] === '0') result = result.substr(2);
  return result[0] !== '0' ? result : result.substr(1);
}

// Zamienia datę na string w formacie H:mm
function dateToHMM (date) {
  let result = date.toISOString().substr(11, 5);
  return result[0] !== '0' ? result : result.substr(1);
}

export function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export function useTimeout(callback, delay) {
  const savedCallback = useRef()

  // Remember the latest callback.
  useEffect(
    () => {
      savedCallback.current = callback
    },
    [callback]
  )

  // Set up the interval.
  useEffect(
    () => {
      function tick() {
        savedCallback.current()
      }
      if (delay !== null) {
        let id = setTimeout(tick, delay)
        return () => clearTimeout(id)
      }
    },
    [delay]
  )
}